// Place-order button label by payment type (pure, unit-tested):
//   immediate payment (card / Viva / PayPal / wallet) → «Ολοκλήρωση & πληρωμή»
//   Klarna                                            → «Μετάβαση στο Klarna»
//   bank transfer + pay-on-delivery (COD/COP)         → «Ολοκλήρωση παραγγελίας»
export function orderCtaLabel(payment, payments) {
  const id = (payment || '').toLowerCase();
  const title = (((payments && payments.methods) || []).find((m) => m.id === payment) || {}).title || '';
  const hay = (id + ' ' + title).toLowerCase();
  if (id === 'cod' || id === 'cop' || id === 'bacs' || hay.indexOf('αντικαταβ') !== -1 || hay.indexOf('τραπεζ') !== -1 || hay.indexOf('παράδοση') !== -1) {
    return 'Ολοκλήρωση παραγγελίας';
  }
  if (hay.indexOf('klarna') !== -1) return 'Μετάβαση στο Klarna';
  return 'Ολοκλήρωση & πληρωμή'; // vivawallet, paypal, cards, wallets → immediate payment
}
